/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.txt = {

    // 5.0 - Populate text array with JSON objects from API call
    saveJSONText: function(results){
        // General UI text 
        var txt = expocadfx.txt;

        txt.AVAILABLE = results.AVAILABLE;
        txt.LEGEND_HOLD = results.LEGEND_HOLD;
        txt.LEGEND_RENTED = results.LEGEND_RENTED;
        txt.LEGEND = results.LEGEND;
        txt.LEGEND_AVAILABLE = results.LEGEND_AVAILABLE;
        txt.EXHIBITOR_LIST = results.EXHIBITOR_LIST;
      
        txt.CATEGORY_LIST = results.CATEGORY_LIST;
        txt.PAVILION_LIST = results.PAVILION_LIST;
        txt.SHOW_IN_SHOW_LIST = results.SHOW_IN_SHOW_LIST;
        txt.COUNTRY_LIST = results.COUNTRY_LIST;
        txt.AVAILABLE_LIST = results.AVAILABLE_LIST;
      
        txt.CONTACT = results.CONTACT;
        txt.PHONE = results.PHONE;
        txt.FAX = results.FAX;
        txt.EMAIL_C = results.EMAIL_C;
        txt.WEB_SITE = results.WEB_SITE;
        txt.PROFILE = results.PROFILE;
        txt.CATEGORIES = results.CATEGORIES;
        txt.NO_CONTACT = results.NO_CONTACT;
      
        txt.EXPIRED = results.EXPIRED;
        txt.FAIL_AUTH = results.FAIL_AUTH;
      
        txt.EXHIBITOR = results.EXHIBITOR;
        txt.BOOTH = results.BOOTH;
        txt.VIEW = results.VIEW;
        txt.VIEW_LIST = results.VIEW_LIST;
        txt.LINK_PREVIEW = results.LINK_PREVIEW;
        txt.SEARCH_PROMPT = results.SEARCH_PROMPT;
        txt.SEARCH = results.SEARCH;
        txt.LOADING = results.LOADING;
        txt.I_AM_HERE = results.I_AM_HERE;
        txt.TT_I_AM_HERE = results.TT_I_AM_HERE;
        txt.TT_MAIL_FRIEND = results.TT_MAIL_FRIEND;
        txt.CANCEL = results.CANCEL;
        txt.CLOSE = results.CLOSE;
        txt.PRINT = results.PRINT;
        txt.TT_PRINT_HALL = results.PRINT_HALL;
        txt.PRINT_FLOORPLAN = results.PRINT_FLOORPLAN;
        txt.PRINT_WINDOW = results.PRINT_WINDOW;
        txt.TT_PRINT_WINDOW = results.TT_PRINT_WINDOW;
        txt.PRINTABLE_PDF = results.PRINTABLE_PDF;
        txt.TT_OPEN_PDF = results.TT_OPEN_PDF;
        txt.VIEW_HELP = results.VIEW_HELP;
        txt.UNITS = results.UNITS;
        txt.BUILDING = results.BUILDING;
        txt.TT_BUILDING_ON = results.TT_BUILDING_ON;
        txt.TT_BUILDING_OFF = results.TT_BUILDING_OFF;
        txt.TT_PRINT_LIST = results.TT_PRINT_LIST;
        txt.TT_PRINT_EXHIBITOR = results.TT_PRINT_EXHIBITOR;
        txt.MAP_ADDRESS = results.MAP_ADDRESS;
        
        txt.MINI_MAP = results.MINI_MAP;

        txt.BOOTH_SIZE = results.BOOTH_SIZE;
        txt.FLOOR_PLAN = results.FLOOR_PLAN;
        txt.EXHIBITORS = results.EXHIBITORS;
        txt.EXHIBITOR_INFO = results.EXHIBITOR_INFO;
        txt.PASSWORD = results.PASSWORD;
        txt.CLEAR_ALL = results.CLEAR_ALL;
        txt.FIT = results.FIT;
        txt.HOME = results.HOME;
        txt.MARK_ON_DRAWING = results.MARK_ON_DRAWING;  // "Highlight";
        txt.RESET = results.RESET;
        txt.EMAIL = results.EMAIL;
        txt.OPEN_EMAIL = results.OPEN_EMAIL;
        txt.MULTI_EXHIBITOR_PROMPT = results.MULTI_EXHIBITOR_PROMPT;
        txt.LOGIN = results.LOGIN;
        txt.EXHIBITOR_FILTER_ALL = results.EXHIBITOR_FILTER_ALL;
        txt.EXHIBITOR_FILTER_HALL = results.EXHIBITOR_FILTER_HALL;
        txt.EXHIBITOR_FILTER_TAGGED = results.EXHIBITOR_FILTER_TAGGED;
        txt.CURRENT = results.CURRENT;
        txt.VERSION = results.VERSION;
        txt.SHOW_COORDS = results.SHOW_COORDS;
        txt.MENU = results.MENU;
        txt.NAVIGATION = results.NAVIGATION;
        txt.FLOOR_PLAN_OPTIONS = results.FLOOR_PLAN_OPTIONS;
        txt.AREA = results.AREA;
        txt.SHOW_3D = "3D";
        txt.SMALL_SHOW_3D = "Show 3D Floor Plan";
        txt.ENTER_PASSWORD = results.ENTER_PASSWORD;
        txt.REQUIRED_PASSWORD = results.REQUIRED_PASSWORD;  //  In fxsalestext !
		txt.OTHER_BOOTHS = results.OTHER_BOOTHS;
		txt.TT_EMAIL_TAGGED_BOOTHS = results.TT_EMAIL_TAGGED_BOOTHS;
		txt.MENU_VIEW = results.MENU_VIEW;
		txt.MENU_TECH_LAYERS = results.MENU_TECH_LAYERS;
		txt.MENU_DIMENSIONS = results.MENU_DIMENSIONS;
		
		txt.LANGUAGE_PREFERENCE = results.LANGUAGE_PREFERENCE;
        txt.REFRESH_REQUIRED = results.REFRESH_REQUIRED;
        
        txt.COPYRIGHT = results.COPYRIGHT;
        
        txt.HELP_TITLE = results.HELP_TITLE;
        txt.HELP_ZOOM_H = results.HELP_ZOOM_H;
        txt.HELP_ZOOM_T = results.HELP_ZOOM_T;
        txt.HELP_PAN_H = results.HELP_PAN_H;
        txt.HELP_PAN_T = results.HELP_PAN_T;
        txt.HELP_EXHIBITOR_H = results.HELP_EXHIBITOR_H;
        txt.HELP_EXHIBITOR_T = results.HELP_EXHIBITOR_T;
        txt.HELP_SEARCH_H = results.HELP_SEARCH_H;
        txt.HELP_SEARCH_T = results.HELP_SEARCH_T;
        txt.HELP_FAVORITES_H = results.HELP_FAVORITES_H;
        txt.HELP_FAVORITES_T = results.HELP_FAVORITES_T;
        
        txt.REFRESH_MESSAGE = results.REFRESH_MESSAGE;

        txt.COPY_BOOTH = results.COPY_BOOTH;

        txt.SALES_COMMANDS = "Rent Booth,Unrent Booth,Hold Booth,Unhold Booth,Combine Booths,Uncombine Booths,Delete Booth,Undelete Booth,New Exhibitor,Divide Booth,Event Statistics,Change Booth Number,Hatch Booths";
        txt.SALES_LABEL = "FX Sales";
        txt.SELECT_BOOTH = "Click a booth to select";
        txt.SELECT_COMPANY = "Select company from list";
        txt.SELECT_RATE = "Select a Rate Plan";
        txt.SELECT_DELETED_BOOTH = "Select booth from list";
        txt.SELECT_CRITERIA = "Select Criteria";
        txt.BOOTH_NUMBER = "Booth Number";
        txt.EXHIBITOR_NAME = "Exhibitor Name";
        txt.EXHIBITOR_ID = "Exhibitor Id";
        txt.RATE_PLAN = "Rate Plan";
        txt.AREA = "Area";
        txt.COMPANY_NAME = "Company Name";
        txt.COMPANY_ID = "Company Id";
        txt.USER_ID = "User Id";
        txt.LOGIN_FAILED = "Login Failed";
        txt.CONNECTING = "Connecting to ";
        txt.SALES_SERVER = "FX Sales Server";
        txt.SALES_LOGIN = "Sales Login";
        txt.SALES_LOGOUT = "Sales Logout";
        txt.NOT_AVAILABLE = "Booth is not Available";
        txt.NOT_RENTED = "Booth is not Rented";
        txt.NOT_ON_HOLD = "Booth is not On Hold";
        txt.NON_RECTANGLE = "Only rectangular booths can be divided";
        txt.ENTER_ID_PASSWORD = "Enter User Id and Password";
        txt.ENTER_BOOTH_NUMBERS = "Enter new booth number";
        txt.ENTER_NEW_COMPANY = "Enter new company name";
        txt.ENTER_NEW_COMPANY_ID = "Enter account id for the new company";
        txt.COMMENT = "Comment";
        txt.DIVIDE = "Divide";
        txt.NUMBER = "Number";
        txt.VERTICAL = "Vertical";
        txt.HORIZONTAL = "Horizontal";
        txt.NEW_COMPANY = "Temporary Exhibitor";
        txt.SELECT_NEW_COMPANY = "or click New Company";
        txt.NEW_NUMBER = "New Number";
        txt.ENTER_NEW_NUMBER = "Enter new number";
        
			
			// for Exhibitor Sales
            txt.SELECT_COMPANY_PASSWORD = "Select Company from list, and enter password";
            txt.REQUIRED_COMPANY_PASSWORD = "Company and Password required";
            
			
			
            txt.arSalesCommands = txt.SALES_COMMANDS.split(",");
    },

    saveJSONSalesText: function(res){
        var txt = expocadfx.txt;
		
        txt.SALES_COMMANDS = "Rent Booth,Unrent Booth,Hold Booth,Unhold Booth,Combine Booths,Uncombine Booths,Delete Booth,Undelete Booth,New Exhibitor,Divide Booth,Event Statistics,Change Booth Number,Hatch Booths";
        txt.SALES_LABEL = "FX Sales";
        txt.SELECT_BOOTH = "Click a booth to select";
        txt.SELECT_COMPANY = "Select company from list";
        txt.SELECT_RATE = "Select a Rate Plan";
        txt.SELECT_DELETED_BOOTH = "Select booth from list";
        txt.SELECT_CRITERIA = "Select Criteria";
        txt.BOOTH_NUMBER = "Booth Number";
        txt.EXHIBITOR_NAME = "Exhibitor Name";
        txt.EXHIBITOR_ID = "Exhibitor Id";
        txt.RATE_PLAN = "Rate Plan";
        txt.AREA = "Area";
        txt.COMPANY_NAME = "Company Name";
        txt.COMPANY_ID = "Company Id";
        txt.USER_ID = "User Id";
        txt.LOGIN_FAILED = "Login Failed";
        txt.CONNECTING = "Connecting to ";
        txt.SALES_SERVER = "FX Sales Server";
        txt.SALES_LOGIN = "Sales Login";
        txt.SALES_LOGOUT = "Sales Logout";
        txt.NOT_AVAILABLE = "Booth is not Available";
        txt.NOT_RENTED = "Booth is not Rented";
        txt.NOT_ON_HOLD = "Booth is not On Hold";
        txt.NON_RECTANGLE = "Only rectangular booths can be divided";
        txt.ENTER_ID_PASSWORD = "Enter User Id and Password";
        txt.ENTER_BOOTH_NUMBERS = "Enter new booth number";
        txt.ENTER_NEW_COMPANY = "Enter new company name";
        txt.ENTER_NEW_COMPANY_ID = "Enter account id for the new company";
        txt.COMMENT = "Comment";
        txt.DIVIDE = "Divide";
        txt.NUMBER = "Number";
        txt.VERTICAL = "Vertical";
        txt.HORIZONTAL = "Horizontal";
        txt.NEW_COMPANY = "Temporary Exhibitor";
        txt.SELECT_NEW_COMPANY = "or click New Company";
        txt.NEW_NUMBER = "New Number";
        txt.ENTER_NEW_NUMBER = "Enter new number";
        
			
			// for Exhibitor Sales
            txt.SELECT_COMPANY_PASSWORD = "Select Company from list, and enter password";
            txt.REQUIRED_COMPANY_PASSWORD = "Company and Password required";
            
			
			
            txt.arSalesCommands = txt.SALES_COMMANDS.split(",");
    },

    saveXMLText: function( results) {
        
        var xml = results.getElementsByTagName( "n");
        
        this.AVAILABLE = xml[0].getAttribute( "xAvail");
        this.LEGEND_HOLD = xml[0].getAttribute( "lblOH");
        this.LEGEND_RENTED = xml[0].getAttribute( "rL");
        this.LEGEND = xml[0].getAttribute( "lL");
        this.LEGEND_AVAILABLE = xml[0].getAttribute( "aL");
        this.EXHIBITOR_LIST = xml[0].getAttribute( "accE");
      
        this.CATEGORY_LIST = xml[0].getAttribute( "accC");
        this.PAVILION_LIST = xml[0].getAttribute( "accP");
        this.SHOW_IN_SHOW_LIST = xml[0].getAttribute( "accSS");
        this.COUNTRY_LIST = xml[0].getAttribute( "accCN");
        this.AVAILABLE_LIST = xml[0].getAttribute( "accA");
      
        this.CONTACT = xml[0].getAttribute("biCo");
        this.PHONE = xml[0].getAttribute("biPh");
        this.FAX = xml[0].getAttribute("biF");
        this.EMAIL_C = xml[0].getAttribute("biE");
        this.WEB_SITE = xml[0].getAttribute("biW");
        this.PROFILE = xml[0].getAttribute("biPr");
        this.CATEGORIES = xml[0].getAttribute("biCa");
        this.NO_CONTACT = xml[0].getAttribute("nCon");
      
        this.EXPIRED = xml[0].getAttribute("F1");
        this.FAIL_AUTH = xml[0].getAttribute("F2");
      
        this.EXHIBITOR = xml[0].getAttribute("lblExh");
        this.BOOTH = xml[0].getAttribute("lblBth");
        this.VIEW = xml[0].getAttribute("lblView");
        this.VIEW_LIST = xml[0].getAttribute("lblVL");
        this.LINK_PREVIEW = xml[0].getAttribute("lblPL");
        this.SEARCH_PROMPT = xml[0].getAttribute("exS");
        this.SEARCH = xml[0].getAttribute( "sL");
        this.LOADING = xml[0].getAttribute( "ldFp");
        this.I_AM_HERE = xml[0].getAttribute( "iah");
        this.TT_I_AM_HERE = xml[0].getAttribute( "ttCC");
        this.TT_MAIL_FRIEND = xml[0].getAttribute( "ttEMF");
        this.CANCEL = xml[0].getAttribute( "rafC");
        this.CLOSE = xml[0].getAttribute( "ttC");
        this.PRINT = xml[0].getAttribute( "pH");
        this.TT_PRINT_HALL = xml[0].getAttribute( "ttPA");
        this.PRINT_FLOORPLAN = xml[0].getAttribute( "lblPF");
        this.PRINT_WINDOW = xml[0].getAttribute( "lblPW");
        this.TT_PRINT_WINDOW = xml[0].getAttribute( "lblPv");
        this.PRINTABLE_PDF = xml[0].getAttribute( "lblPP");
        this.TT_OPEN_PDF = xml[0].getAttribute( "ttPP");
        this.VIEW_HELP = xml[0].getAttribute( "ttH");
        this.UNITS = xml[0].getAttribute( "lblUnits");
        this.BUILDING = xml[0].getAttribute( "lblBuild");
        this.TT_BUILDING_ON = xml[0].getAttribute( "ttB1");
        this.TT_BUILDING_OFF = xml[0].getAttribute( "ttB0");
        this.TT_PRINT_LIST = xml[0].getAttribute( "ttPL");
        this.TT_PRINT_EXHIBITOR = xml[0].getAttribute( "ttPI");
        this.MAP_ADDRESS = xml[0].getAttribute( "ttMI");
        
        this.MINI_MAP = xml[0].getAttribute( "mMl");

        this.NEW_MAP_ADDRESS = "";
        this.BOOTH_SIZE = "Size";
        this.FLOOR_PLAN = "Floor Plan";
        this.EXHIBITORS = "Exhibitors";
        this.EXHIBITOR_INFO = "Exhibitor Info";
        this.PASSWORD = "Password";
        this.CLEAR_ALL = "Clear";
        this.FIT = "Fit";
        this.SHOW_3D = "3D";
        this.HOME = "Home";
        this.MARK_ON_DRAWING = "Tag";  // "Highlight";
        this.RESET = "Reset";
        this.EMAIL = "Email";
        this.OPEN_EMAIL = "Open Email";
        this.MULTI_EXHIBITOR_PROMPT = "select an exhibitor";
        this.LOGIN = "Login";
        this.EXHIBITOR_FILTER_ALL = "All Exhibitors";
        this.EXHIBITOR_FILTER_HALL = "This Hall";
        this.EXHIBITOR_FILTER_TAGGED = "Tagged";
        this.CURRENT = "Current as of ";
        this.VERSION = "ver. ";
        this.SHOW_COORDS = "Show Coordinates";
        this.MENU = "Menu";
        this.NAVIGATION = "Navigation";
        this.FLOOR_PLAN_OPTIONS = "Floor Plan Options";
        this.AREA = "Area";
        this.SMALL_SHOW_3D = "Show 3D Floor Plan";
        this.ENTER_PASSWORD = "Enter Password";
        this.REQUIRED_PASSWORD = "Password is Required";  //  In fxsalestext !
		this.OTHER_BOOTHS = "Other Booths";
		this.TT_EMAIL_TAGGED_BOOTHS = "E-Mail tagged booths";
		this.MENU_VIEW = "View";
		this.MENU_TECH_LAYERS = "Technical Layers";
		this.MENU_DIMENSIONS = "Booth Dimensions";
		
		this.LANGUAGE_PREFERENCE = "Language Preference";
        this.REFRESH_REQUIRED = "Refresh Required";
        
        this.COPYRIGHT = " Copyright© 2020 A.C.T. Inc. All rights reserved";
        
        this.HELP_TITLE = xml[0].getAttribute( "hExFx");
        this.HELP_ZOOM_H = xml[0].getAttribute( "hZl");
        this.HELP_ZOOM_T = xml[0].getAttribute( "hZh");
        this.HELP_PAN_H = xml[0].getAttribute( "hPl");
        this.HELP_PAN_T = xml[0].getAttribute( "hPh");
        this.HELP_EXHIBITOR_H = xml[0].getAttribute( "hIl");
        this.HELP_EXHIBITOR_T = xml[0].getAttribute( "hIh");
        this.HELP_SEARCH_H = xml[0].getAttribute( "hSl");
        this.HELP_SEARCH_T = xml[0].getAttribute( "hSh");
        this.HELP_FAVORITES_H = xml[0].getAttribute( "hFl");
        this.HELP_FAVORITES_T = xml[0].getAttribute( "hFh");
        
        this.REFRESH_MESSAGE = xml[0].getAttribute( "uAmsg");

        this.COPY_BOOTH = xml[0].getAttribute("copyBooth");
        
//        this.RENT_MODE_LABEL = xml[0].getAttribute( "rm");
//        this.HOLD_MODE_LABEL = xml[0].getAttribute( "hm");
    },
    
    
    saveXMLSalesText : function( results) {
        var txt = expocadfx.txt;
//        if( success) {
            var xml = results.getElementsByTagName( "n")[0];
		
            txt.SALES_COMMANDS = xml.getAttribute("cmds");  //  ? straight to array
            txt.SALES_LABEL = xml.getAttribute("lbl");
            txt.SELECT_BOOTH = xml.getAttribute( "clkb");
            txt.SELECT_COMPANY = xml.getAttribute( "sele");
            txt.SELECT_RATE = xml.getAttribute( "selr");
            txt.SELECT_DELETED_BOOTH = xml.getAttribute( "selb");
            txt.SELECT_CRITERIA = "Select Criteria";
            txt.BOOTH_NUMBER = xml.getAttribute( "bn");
            txt.EXHIBITOR_NAME = xml.getAttribute( "en");
            txt.EXHIBITOR_ID = xml.getAttribute( "ei");
            txt.RATE_PLAN = xml.getAttribute( "rp");
            txt.COMMENT = "Comment";
            txt.COMPANY_NAME = xml.getAttribute( "cn");
            txt.COMPANY_ADDRESS_ONE = xml.getAttribute( "eao");
            txt.COMPANY_ADDRESS_TWO = xml.getAttribute( "eat");
            txt.COMPANY_CITY = xml.getAttribute( "eci");
            txt.COMPANY_STATE = xml.getAttribute( "est");
            txt.COMPANY_COUNTRY = xml.getAttribute( "ecou");
            txt.COMPANY_POSTAL_CODE = xml.getAttribute( "epc");
            txt.COMPANY_PHONE_NUMBER = xml.getAttribute( "eph");
            txt.COMPANY_CONTACT_NAME = xml.getAttribute( "econ");
            txt.COMPANY_FAX = xml.getAttribute( "efax");
            txt.COMPANY_EMAIL = xml.getAttribute( "eem");
            txt.COMPANY_WEB_SITE = xml.getAttribute( "ews");
            txt.COMPANY_PROFILE = xml.getAttribute( "ecp");
            txt.COMPANY_ID = xml.getAttribute( "ci");
            txt.USER_ID =    xml.getAttribute( "uid");
            txt.SALES_LOGIN = xml.getAttribute( "lgin");
            txt.SALES_LOGOUT = xml.getAttribute( "lgout");
            txt.LOGIN_FAILED = xml.getAttribute( "fldprmt");
            txt.NOT_AVAILABLE = xml.getAttribute( "notAvail");
            txt.NOT_RENTED = xml.getAttribute( "notRent");
            txt.NOT_ON_HOLD = xml.getAttribute( "notHold");
            txt.CONNECTING = xml.getAttribute( "cnct");
            txt.SALES_SERVER = xml.getAttribute( "srv");
            txt.REQUIRED_ID_PASSWORD = xml.getAttribute( "reqUP");
            txt.CHARACTER_LIMIT = xml.getAttribute("charLim");
            
            txt.DIVIDE = xml.getAttribute( "lblDiv");
            txt.NUMBER = xml.getAttribute( "lblNum");
            txt.VERTICAL = xml.getAttribute( "lblVer");
            txt.HORIZONTAL = xml.getAttribute( "lblHor");
            txt.ENTER_BOOTH_NUMBERS = xml.getAttribute( "entBthNum");
            txt.NON_RECTANGLE = xml.getAttribute( "notRect");
            txt.SELECT_NEW_COMPANY = xml.getAttribute( "clkNewCo");
            txt.NEW_COMPANY = xml.getAttribute("lblNewCo");
            txt.ENTER_NEW_COMPANY = xml.getAttribute( "entCoName");
            txt.ENTER_NEW_COMPANY_ID = xml.getAttribute( "entCoId");
            txt.ENTER_ID_PASSWORD = xml.getAttribute( "entIdPs");
			txt.NEW_NUMBER = xml.getAttribute( "lblNewNum");
			txt.ENTER_NEW_NUMBER = xml.getAttribute( "entNewNum");
			
			// for Exhibitor Sales
            txt.SELECT_COMPANY_PASSWORD = "Select Company from list, and enter password";
            txt.REQUIRED_COMPANY_PASSWORD = "Company and Password required";
            
			
			
            txt.arSalesCommands = txt.SALES_COMMANDS.split(",");
            
            // "You are not authorized to use program at this time." - FOR AUTH KEY, COULD ALSO BE IN EXH SALES
            
            
//        }
//        else {
//            alert( "Missing text file required for FX Sales");
//        }
    },

    defaultText: function(){

        this.AREA = "Area"
        this.AVAILABLE = "Available"
        this.AVAILABLE_LIST = "Available Booth List"
        this.BOOTH = "Booth"
        this.BOOTH_SIZE = "Size"
        this.BUILDING = "Building"
        this.CANCEL = "Cancel"
        this.CATEGORIES = "Categories"
        this.CATEGORY_LIST = "Category List"
        this.CLEAR_ALL = "Clear"
        this.CLOSE = "Close"
        this.CONTACT = "Contact"
        this.COPYRIGHT = " Copyright© 2020 A.C.T. Inc. All rights reserved"
        this.COUNTRY_LIST = "Country List"
        this.CURRENT = "Current as of "
        this.EMAIL = "Email"
        this.EMAIL_C = "E-Mail"
        this.ENTER_PASSWORD = "Enter Password"
        this.EXHIBITOR = "Exhibitor"
        this.EXHIBITORS = "Exhibitors"
        this.EXHIBITOR_FILTER_ALL = "All Exhibitors"
        this.EXHIBITOR_FILTER_HALL = "This Hall"
        this.EXHIBITOR_FILTER_TAGGED = "Tagged"
        this.EXHIBITOR_INFO = "Exhibitor Info"
        this.EXHIBITOR_LIST = "Exhibitor List"
        this.EXPIRED = "THIS SHOW HAS EXPIRED PLEASE CONTACT SHOW MANAGEMENT FOR MORE INFORMATION."
        this.FAIL_AUTH = "THIS SHOW CANNOT LOAD DUE TO CONFIGURATION PARAMETER INCONSISTENCIES."
        this.FAX = "Fax"
        this.FIT = "Fit"
        this.FLOOR_PLAN = "Floor Plan"
        this.FLOOR_PLAN_OPTIONS = "Floor Plan Options"
        this.HELP_EXHIBITOR_H = "To View Exhibitor Info"
        this.HELP_EXHIBITOR_T = "Click a booth on the map to view the exhibitor info. You can print the exhibitor info by clicking the Print Info button. You can contact the exhibitor by clicking the Email button or visit the exhibitor's website by clicking the Web button."
        this.HELP_FAVORITES_H = "To Use The Favorites"
        this.HELP_FAVORITES_T = "You can select booths to be your favorites and store them for later use. To add a favorite click on a booth on the main floor plan. In the booth info box click the Add Favorite button(Star+). This booth is now in your favorites and you can reference the favorites at any time by clicking the View Favorites button(Star) on the main application. This highlights and zooms to all your favorites. To remove favorites you can select individual booths by clicking on them in the list and clicking the Remove Favorite button(Star-). You can also remove or review your favorites in the Favorites Editor. To open the Favorites Editor click the Edit Favorites button(Pencil/Star). From there you can remove individual favorites by selecting them in the list and clicking Remove Favorite(-) or you can remove all your favorites by clicking the Remove All Favorites button(-all)."
        this.HELP_PAN_H = "You can zoom by clicking the +/- buttons on the right}); by clicking and dragging the zoom slider}); or by scrolling your mouse wheel."
        this.HELP_PAN_T = "You can pan the map by using the 4 directional arrows on the right}); by clicking and dragging the selection box on the minimap}); or by clicking and dragging anywhere on the main map that is not a booth."
        this.HELP_SEARCH_H = "To Use The Search"
        this.HELP_SEARCH_T = "The search is unique in that it will automatically perform the search 1 second after you stop typing.  If you type only one letter the search will return all the exhibitors whose name starts with that letter.  If you type more than one letter the search will return all the exhibitors whose name contains the search string you have entered."
        this.HELP_TITLE = "EXPOCAD FX HELP"
        this.HELP_ZOOM_H = "To Zoom"
        this.HELP_ZOOM_T = "You can zoom by clicking the +/- buttons on the right}); by clicking and dragging the zoom slider}); or by scrolling your mouse wheel."
        this.HOME = "Home"
        this.I_AM_HERE = "I AM HERE!"
        this.LANGUAGE_PREFERENCE = "Language Preference"
        this.LEGEND = "Legend"
        this.LEGEND_AVAILABLE = "Available"
        this.LEGEND_HOLD = "On Hold"
        this.LEGEND_RENTED = "Rented"
        this.LINK_PREVIEW = "Preview Link"
        this.LOADING = "Loading Floorplan"
        this.LOGIN = "Login"
        this.MAP_ADDRESS = "Map Exhibitor Address"
        this.MARK_ON_DRAWING = "Tag"
        this.MENU = "Menu"
        this.MENU_DIMENSIONS = "Booth Dimensions"
        this.MENU_TECH_LAYERS = "Technical Layers"
        this.MENU_VIEW = "View"
        this.MINI_MAP = "Mini Map"
        this.MULTI_EXHIBITOR_PROMPT = "select an exhibitor"
        this.NAVIGATION = "Navigation"
        this.NO_CONTACT = "No Contact Information Available"
        this.OPEN_EMAIL = "Open Email"
        this.OTHER_BOOTHS = "Other Booths"
        this.PASSWORD = "Password"
        this.PAVILION_LIST = "Pavilion List"
        this.PHONE = "Phone"
        this.PRINT = "Print"
        this.PRINTABLE_PDF = "Printable PDF"
        this.PRINT_FLOORPLAN = "Print Floorplan"
        this.PRINT_WINDOW = "Print Window"
        this.PROFILE = "Profile"
        this.REFRESH_MESSAGE = "Please refresh your browser window to update the floorplan"
        this.REFRESH_REQUIRED = "Refresh Required"
        this.REQUIRED_PASSWORD = "Password is Required"
        this.RESET = "Reset"
        this.SEARCH = "Search"
        this.SEARCH_PROMPT = "Type a Name or Number"
        this.SHOW_3D = "3D"
        this.SHOW_COORDS = "Show Coordinates"
        this.SHOW_IN_SHOW_LIST = "Show in Show List"
        this.SMALL_SHOW_3D = "Show 3D Floor Plan"
        this.TT_BUILDING_OFF = "Toggle Building Off"
        this.TT_BUILDING_ON = "Toggle Building On"
        this.TT_EMAIL_TAGGED_BOOTHS = "E-Mail tagged booths"
        this.TT_I_AM_HERE = "Choose I Am Here Coordinates"
        this.TT_MAIL_FRIEND = "Email a Friend"
        this.TT_OPEN_PDF = "Open Printable PDF"
        this.TT_PRINT_EXHIBITOR = "Print Current List"
        this.TT_PRINT_HALL = "Print Entire Hall"
        this.TT_PRINT_LIST = "NO TRANSLATION FOUND"
        this.UNITS = "Units"
        this.VERSION = "ver. "
        this.VIEW = "View"
        this.VIEW_HELP = "View Help"
        this.VIEW_LIST = "View List"
        this.WEB_SITE = "Web site"
    }
};